import React, { useEffect, useState } from 'react';
import RulesComponentHolder from '../../styles/rulesComponentStyle';
import { useTranslation } from 'react-i18next';
import { Tooltip, Button, Icon, Tag } from 'antd';
import Colors from '../../../../../themes/Colors';

const ListRulesComponent = props => {
  const { t } = useTranslation();
  const { showModalRules } = props;
  const { listContentDisplay, styleRules, defaultText, type } = props;
  // styleRules: per-slot style overrides, so each caller decides how its own
  // rules block looks: { container, chip, badges }.
  const { container = {}, chip = {}, badges = {} } = styleRules || {};
  const [rulesAppliedInContentDisplay, setRulesAppliedInContentDisplay] = useState([]);
  const [existRulesInContentDisplay, setExistRulesInContentDisplay] = useState(false);

  const getRulesAppliedInContentDisplay = () => {
    const repeatedRules = [];
    let hasAnyRuleApplied = false;
    let existRules = false;
    if (listContentDisplay.length === 0) {
      return repeatedRules;
    }
    const firstContentDisplay = listContentDisplay[0];
    const rulesOfFirstContentDisplay = firstContentDisplay.rules || [];
    /**
     * [IMPORTANT] => If the first content display has rules is a content, but if it has no rules is a group of content displays or a display
     */
    if (rulesOfFirstContentDisplay.length === 0) {
      hasAnyRuleApplied = listContentDisplay.some(cd => cd.rules && cd.rules.length > 0);
      if (hasAnyRuleApplied) existRules = true;
      setExistRulesInContentDisplay(existRules);
      return repeatedRules;
    }
    rulesOfFirstContentDisplay.forEach(rule => {
      const isRepeated = listContentDisplay.every(
        contentDisplay =>
          contentDisplay.rules &&
          contentDisplay.rules.some(r => r.configRules.id === rule.configRules.id)
      );
      const isAlreadyExistRuleInArray = repeatedRules.some(
        r => r.configRules.id === rule.configRules.id
      );
      //TODO: Improve this validation.
      if (isAlreadyExistRuleInArray) return;
      if (isRepeated) {
        repeatedRules.push(rule);
      } else {
        hasAnyRuleApplied = true;
        existRules = true;
      }
    });
    const allFirstRuleIds = new Set(rulesOfFirstContentDisplay.map(r => r.configRules.id));
    const hasExtraRules = listContentDisplay.some(
      cd => cd.rules && cd.rules.some(rule => !allFirstRuleIds.has(rule.configRules.id))
    );
    if (hasExtraRules) {
      hasAnyRuleApplied = true;
      existRules = true;
    }
    setExistRulesInContentDisplay(existRules);
    return repeatedRules;
  };

  useEffect(() => {
    let listRules = getRulesAppliedInContentDisplay();
    setRulesAppliedInContentDisplay(listRules);
  }, [listContentDisplay]);

  const maxVisibleRules = 5;
  const visibleRules = rulesAppliedInContentDisplay.slice(0, maxVisibleRules);
  const remainingRules = rulesAppliedInContentDisplay.slice(maxVisibleRules);
  const allRuleNames = rulesAppliedInContentDisplay.map(rule => rule.configRules.name).join('\n');

  return (
    <RulesComponentHolder>
      <div className="titleRuleList">
        {t('Rules')}
        <Tooltip title={t('Set up rules in this display')}>
          <Button
            shape="circle"
            className="buttonActionsGroup"
            style={{ marginLeft: '10px' }}
            onClick={() => showModalRules()}
          >
            <Icon type="control" />
          </Button>
        </Tooltip>
      </div>
      {rulesAppliedInContentDisplay.length !== 0 ? (
        <>
          <div
            onClick={event => {
              event.stopPropagation();
              showModalRules();
            }}
            className="rulesContainer"
            style={{
              justifyContent: 'flex-start',
              maxWidth: '300px',
              flexWrap: 'wrap',
              ...container
            }}
          >
            <div
              className="nameRules"
              style={{ whiteSpace: 'normal', wordBreak: 'break-word', ...chip }}
            >
              <Tooltip title={allRuleNames}>
                <span style={badges}>
                  {visibleRules.map((rule, index) => (
                    <Tag
                      key={index}
                      style={{
                        backgroundColor: Colors.extraLightPrimary,
                        color: Colors.primaryAccent,
                        border: 'none',
                        margin: '2px 5px 2px 0',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {rule.configRules.name}
                    </Tag>
                  ))}
                  {remainingRules.length > 0 && (
                    <Tag
                      style={{
                        backgroundColor: Colors.primary,
                        color: Colors.onPrimary,
                        border: 'none',
                        margin: '2px 0'
                      }}
                    >
                      +{remainingRules.length}
                    </Tag>
                  )}
                </span>
              </Tooltip>
              {listContentDisplay.length > 0 && type != 'relation' && (
                <span style={{ marginLeft: '5px', color: Colors.textMuted }}>
                  <br />
                  {type === 'display' ? t('throughout the display') : t('throughout the group')}
                </span>
              )}
            </div>
          </div>
          {existRulesInContentDisplay && (
            <div style={{ display: 'flex', justifyContent: container.justifyContent || 'center' }}>
              <div
                onClick={event => {
                  event.stopPropagation();
                  showModalRules();
                }}
                className="rulesContainer nameRules"
                style={{
                  justifyContent: 'flex-start',
                  maxWidth: '300px',
                  flexWrap: 'wrap',
                  ...container
                }}
              >
                <p
                  className={!existRulesInContentDisplay ? 'textInfoRule' : 'textInfoRuleWithRules'}
                >
                  {t('Other applied rule(s)')}
                </p>
              </div>
            </div>
          )}
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: container.justifyContent || 'center' }}>
          <div
            onClick={event => {
              event.stopPropagation();
              showModalRules();
            }}
            className="nameRules"
            style={{ justifyContent: 'flex-start', ...container }}
          >
            <p className={!existRulesInContentDisplay ? 'textInfoRule' : 'textInfoRuleWithRules'}>
              {!existRulesInContentDisplay ? defaultText : t('Rule(s) applied')}
            </p>
          </div>
        </div>
      )}
    </RulesComponentHolder>
  );
};

export default ListRulesComponent;
